var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("ContentWithHeader", {
    scopedSlots: _vm._u([
      {
        key: "header",
        fn: function() {
          return [
            _c(
              "button",
              {
                staticClass: "btn no-bg",
                on: {
                  click: function($event) {
                    return _vm.setPosSection("choose-product")
                  }
                }
              },
              [_c("i", { staticClass: "fas fa-times" })]
            )
          ]
        },
        proxy: true
      },
      {
        key: "content",
        fn: function() {
          return [
            _c("div", { staticClass: "wrapper-content" }, [
              _c("div", { staticClass: "row" }, [
                _c("div", { staticClass: "col-12 mt-4 mb-2" }, [
                  _c("strong", [
                    _vm._v(
                      "\n            " +
                        _vm._s(_vm.$t("apps.pos.message.categories")) +
                        "\n          "
                    )
                  ])
                ])
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "container-items row" },
                _vm._l(_vm.mapCategories, function(cat, index) {
                  return cat.productCount > 0 || ["1", "2"].includes(cat.id)
                    ? _c(
                        "div",
                        {
                          key: index,
                          staticClass: "item",
                          on: {
                            click: function($event) {
                              return _vm.handleClickCategory(cat.id)
                            }
                          }
                        },
                        [
                          _c("div", { staticClass: "info" }, [
                            cat.icon.name
                              ? _c("span", { staticClass: "icon mr-3" }, [
                                  _c("i", {
                                    class: [cat.icon.name],
                                    style: [
                                      { width: cat.icon.size },
                                      { color: cat.icon.color }
                                    ]
                                  })
                                ])
                              : _vm._e(),
                            _vm._v(" "),
                            _c("span", [
                              _vm._v(
                                "\n              " +
                                  _vm._s(cat.name) +
                                  "\n            "
                              )
                            ])
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "count" }, [
                            _vm._v(
                              "\n            " +
                                _vm._s(cat.productCount) +
                                "\n          "
                            )
                          ])
                        ]
                      )
                    : _vm._e()
                }),
                0
              )
            ])
          ]
        },
        proxy: true
      }
    ])
  })
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-40a44860", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-40a44860","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/apps/pos/sale/mobile/include/CategoryList.vue
// module id = null
// module chunks = 